import axios from "axios";
import { getDeviceId } from "@/lib/device";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

// Downscale + compress a dataURL to keep AI cost + payload small.
export function compressDataUrl(dataUrl, maxDim = 1024, quality = 0.72) {
  return new Promise((resolve) => {
    const img = new Image();
    img.onload = () => {
      let { width, height } = img;
      if (width > height && width > maxDim) {
        height = Math.round((height * maxDim) / width);
        width = maxDim;
      } else if (height >= width && height > maxDim) {
        width = Math.round((width * maxDim) / height);
        height = maxDim;
      }
      const canvas = document.createElement("canvas");
      canvas.width = width;
      canvas.height = height;
      const ctx = canvas.getContext("2d");
      ctx.drawImage(img, 0, 0, width, height);
      resolve(canvas.toDataURL("image/jpeg", quality));
    };
    img.src = dataUrl;
  });
}

export async function uploadSnap(imageBase64, role) {
  const res = await axios.post(`${API}/snaps`, {
    device_id: getDeviceId(),
    image_base64: imageBase64,
    role,
  });
  return res.data;
}

export async function compareSnaps(beforeId, afterId, opts = {}) {
  const res = await axios.post(`${API}/compare`, {
    device_id: getDeviceId(),
    before_id: beforeId,
    after_id: afterId,
    fridge_code: opts.fridge_code || null,
    member_name: opts.member_name || null,
  });
  return res.data;
}

export async function getComparison(id) {
  const res = await axios.get(`${API}/comparison/${id}`);
  return res.data;
}

export async function getTimeline() {
  const res = await axios.get(`${API}/timeline/${getDeviceId()}`);
  return res.data;
}

export async function createFridge(name, memberName) {
  const res = await axios.post(`${API}/fridges`, {
    device_id: getDeviceId(),
    name: name || null,
    member_name: memberName || null,
  });
  return res.data;
}

export async function joinFridge(code, memberName) {
  const res = await axios.post(`${API}/fridges/${code}/join`, {
    device_id: getDeviceId(),
    member_name: memberName,
  });
  return res.data;
}

export async function getFridge(code) {
  const res = await axios.get(`${API}/fridges/${code}`);
  return res.data;
}

export async function createRecipes(snapId, diet, effort, cuisine) {
  const res = await axios.post(`${API}/recipes`, {
    device_id: getDeviceId(),
    snap_id: snapId,
    diet,
    effort,
    cuisine: cuisine || "any",
  });
  return res.data;
}

export async function getRecipes(id) {
  const res = await axios.get(`${API}/recipes/${id}`);
  return res.data;
}

export async function getCooks() {
  const res = await axios.get(`${API}/cooks/${getDeviceId()}`);
  return res.data;
}
